
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    id: 1,
    title: 'اكتشفي جمالك الطبيعي',
    subtitle: 'مجموعة حصرية من منتجات العناية بالبشرة الفاخرة',
    image: 'https://public.readdy.ai/ai/img_res/0280c0f07df05f019d5847ff3e0232a2.jpg',
    cta: 'تسوقي الآن',
    link: '/shop'
  },
  {
    id: 2,
    title: 'مكياج يدوم طوال اليوم',
    subtitle: 'أحدث صيحات المكياج العصري بألوان رائعة',
    image: 'https://readdy.ai/api/search-image?query=elegant%20makeup%20products%20lipstick%20blush%20palette%20on%20soft%20pink%20background%2C%20luxury%20cosmetics%20flatlay%20photography%2C%20rose%20gold%20accents%2C%20minimalist%20beauty%20aesthetic%2C%20professional%20product%20photography%20with%20soft%20shadows%2C%20feminine%20and%20modern%20style&width=1920&height=800&seq=hero2&orientation=landscape',
    cta: 'اكتشفي المجموعة',
    link: '/makeup'
  },
  {
    id: 3,
    title: 'عطور تأسر الحواس',
    subtitle: 'روائح فاخرة تعكس أنوثتك وجمالك',
    image: 'https://readdy.ai/api/search-image?query=luxury%20perfume%20bottle%20with%20pink%20rose%20mist%20spray%20on%20elegant%20pink%20background%2C%20sophisticated%20fragrance%20photography%2C%20soft%20romantic%20lighting%2C%20minimalist%20beauty%20product%20display%2C%20feminine%20aesthetic%20with%20rose%20petals%2C%20high-end%20cosmetic%20advertising&width=1920&height=800&seq=hero3&orientation=landscape',
    cta: 'اكتشفي العطور',
    link: '/fragrance'
  }
];

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <div className="relative h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="relative w-full h-full">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
            
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center px-4 max-w-3xl">
                <h2 className="text-5xl lg:text-6xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {slide.title}
                </h2>
                <p className="text-xl text-white/90 mb-8">
                  {slide.subtitle}
                </p>
                <Link
                  to={slide.link}
                  className="inline-block bg-rose-400 text-white px-10 py-4 rounded-full text-base font-medium hover:bg-rose-500 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  {slide.cta}
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* المؤشرات */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
            }`}
          />
        ))}
      </div>

      {/* أزرار التنقل */}
      <button
        onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full text-white hover:bg-white/30 transition-colors z-10 cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>
      <button
        onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full text-white hover:bg-white/30 transition-colors z-10 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
    </div>
  );
};

export default HeroSlider;
